<template>
    <div class="categ_info" v-if="obj_to_null(this.cur_item)">
        <div class="button_add mb-4">
            <button class="btn btn-md btn-block btn-outline-info waves-effect waves-themed" v-on:click="add_prod()">
                <span class="fal  fa-eject mr-1"></span>
                {{__t('SELECT_PRODUCT')}}
            </button>

            <div class="prod_info" v-if="this.cur_item.is_product && this.obj_to_null(this.attached_product)">
                <div class="user_profile bg-gradient-primary bd-callout bd-callout-info position-relative mt-2  px-2 p-1">
                    <div class="d-flex flex-row pt-2 pb-1">
                        <span class="status">
                            <img class="profile-image rounded-circle d-inline-block" :src="attached_prod_image">
                        </span>
                        <div class="user_attrib ml-3">
                            <div class="name d-block fw-700 text-dark">
                                {{attached_prod_title}}
                            </div>
                            <div class="company small text-dark">
                                {{this.attached_product.price}}
                            </div>
                        </div>
                    </div>
                    <div class="clr"></div>
                </div>
            </div>
        </div>

        <div class="redraw_block" v-if="!is_set_data">
            <info_field f_uniq="ct"
                        f_type="name"
                        :is_disabled="false"
                        @update_categ="change_atr"
                        :f_title="__t('NAME')"
                        :f_val="cur_item.name">

            </info_field>

            <div class="form-group mt-2">
                <label class="form-label" for="organization">
                    {{__t("GROUP")}}
                </label>

                <div class="" v-if="groups.length > 0">
                    <v-select v-model="active_group"
                              class="imc_reasons"
                              label="title"
                              :options="this.groups"
                              :filterable="false"
                    >
                        <template slot="no-options">
                            {{__t("CHOICE_ORG")}}
                        </template>

                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{ option.title }}
                                </div>
                                <div>
                                    <small>
                                        {{option.uniq_id}}
                                    </small>

                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </div>


            <info_field
                f_uniq="cid"
                f_type="uniq_id"
                :is_disabled="false"
                @update_categ="change_atr"
                :f_title="__t('UNIQ_ID_CODE')"
                :f_val="cur_item.uniq_id">
            </info_field>

            <div class="skeep_sync mt-5">
                <h5 class="frame-heading">{{__t("SKEEP_TTL")}}</h5>
                <div class="custom-control custom-checkbox custom-control-inline">
                    <input type="checkbox" v-model="cur_item.skeep_sync" class="custom-control-input" id="skeep_sync">
                    <label class="custom-control-label" for="skeep_sync">{{__t("SKEEP_SYNC")}}</label>
                </div>
            </div>


            <info_field
                f_uniq="qty"
                f_type="max_qual"
                :is_disabled="false"
                @update_categ="change_atr"
                :f_title="__t('MAX_QTY')"
                :f_val="cur_item.max_qual.toString()">
            </info_field>

            <info_field
                f_uniq="cid3"
                :f_title="__t('UNIQ_PROV_CODE')"
                :f_val="cur_item.id.toString()">
            </info_field>

            <info_field
                :is_disabled="false"
                 f_uniq="cid4"
                f_type="price"
                @update_categ="change_atr"
                :f_title="__t('PRICE')"
                :f_val="cur_item.price.toString()">
            </info_field>

            <info_field
                :is_disabled="false"
                f_uniq="cid5"
                f_type="ordering"
                @update_categ="change_atr"
                :f_title="__t('ORDERING')"
                :f_val="cur_item.ordering.toString()">
            </info_field>
        </div>


        <h5 class="frame-heading mt-4">{{__t("PUBLISHED_TTL")}}</h5>
        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.published" class="custom-control-input" id="publish">
            <label class="custom-control-label" for="publish">{{__t("PUBLISHED")}}</label>
        </div>


        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.hidden" class="custom-control-input" id="hidden">
            <label class="custom-control-label" for="hidden">{{__t("HIDDEN")}}</label>
        </div>

        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.skeep_send" class="custom-control-input" id="skeep_send">
            <label class="custom-control-label" for="skeep_send">{{__t("SKEEP_SEND")}}</label>
        </div>

        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.is_comment" class="custom-control-input" id="is_comment">
            <label class="custom-control-label" for="is_comment">{{__t('IS_COMMENT')}}</label>
        </div>

        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.ignore_discount" class="custom-control-input" id="ignore_discount">
            <label class="custom-control-label" for="ignore_discount">{{__t("IGNORE_DISCOUNT")}}</label>
        </div>

        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.is_default" class="custom-control-input" id="is_default">
            <label class="custom-control-label" for="is_default">{{__t("IS_DEFAULT")}}</label>
        </div>

        <div class="custom-control custom-checkbox custom-control-inline">
            <input type="checkbox" v-model="cur_item.table_hidden" class="custom-control-input" id="table_hidden">
            <label class="custom-control-label" for="table_hidden">{{__t("TABLE_HIDDEN")}}</label>
        </div>


        <product_modal_list></product_modal_list>
    </div>

</template>

<script>
    import Info_field from "../../../../sys/info_field.vue";
    import vSelect from 'vue-select'
    import Product_modal_list from "../../../products/modal_list/product_modal_list.vue";
    export default {
        name: "m_info",
        components: {Product_modal_list, Info_field,vSelect},
        props : {
            modif : {
                type : Object
            }
        },
        created() {
            EventBus.$on('selected_prod',this.set_prod);
            this.cur_item = this.modif;
            this.load_groups();
        },

        beforeDestroy() {
            EventBus.$off('selected_prod',this.set_prod);
        },


        data() {
            return {
                cur_item : {},
                is_load: false,
                groups : [],
                is_set_data : false,
            }
        },
        methods :  {

            set_prod(cur_prod) {
                this.is_set_data = true;
                console.log(cur_prod);
                try {
                    this.change_atr("uniq_id", cur_prod.uniq_id);
                    this.change_atr("name", cur_prod.title);
                    this.change_atr("price", cur_prod.price);
                    this.change_atr("is_product", 1);
                    this.cur_item.attached_product = null;
                }
                catch (e) {
                    console.log(e);
                }
                setTimeout(() => {
                    this.is_set_data = false;
                },500);


            },

            async add_prod() {
                EventBus.$emit('select_product_modal');
            },

            async load_groups() {
                this.groups = [];
                this.is_load = true;

                await api.post('/internal/v1/catalog/modifiers/groups').then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.groups = data.data;
                        this.groups.map(item => {
                            item.is_active = false;
                        })

                    } else {
                        this.groups = [];
                    }
                }).catch(({response}) => {
                    this.is_load = false;
                    this.groups = [];
                    EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                });
            },

            change_atr(atr_name,atr_val) {

                if(this.modif.hasOwnProperty(atr_name)) {
                    this.modif[atr_name] = atr_val;
                    this.$set(this.cur_item,atr_name,atr_val);
                    this.$set(this.modif,atr_name,atr_val);
                }
            }
        },
        computed : {
            is_disabled () {
                return this.cur_item.id > 0;
            },

            attached_product() {
                try {
                    if (this.cur_item.attached_product != null) {
                        return this.cur_item.attached_product;
                    }
                }
                catch (e) {

                }


                return null;
            },

            attached_prod_title() {
                try {
                    return this.attached_product.title;
                }
                catch (e) {

                }

                return "";
            },

            attached_prod_image() {
                if(this.attached_product != null) {
                    // '/product/'.$prod['id'].'/image/'.$prod['client_id'].'/700/700/'. $glovo_prod->id.'.webp'
                    return  '/product/' + this.attached_product.id +'/image/' + this.attached_product.client_id +'/100/100/' +this.attached_product.client_id  +'.webp'
                }
                return "";
            },


            active_group : {
                get :function () {
                    let active = null;
                    if(this.groups.length > 0) {
                        if(this.modif.hasOwnProperty("group_id")) {
                            this.groups.map(item => {
                                if(parseInt(item.id) === parseInt(this.modif.group_id)) {
                                    active = item;
                                }
                            })
                        }
                    }
                    return active;
                },

                set: function (val){
                    if(val != null) {
                        if (this.modif.hasOwnProperty("group_id")) {
                            this.modif.group_id = val.id;
                        }
                    }
                    else {
                        this.modif.group_id = 0;
                    }
                },
            },

        },
    }
</script>

<style scoped>

</style>
